var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogoCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4244.78 795.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ea4025;}.cls-4{fill:#eb5626;}.cls-5{fill:#ea7c25;}.cls-6{fill:#eb5627;}path{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 918.13,
    height: 795.23
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M603.43,627.75H314.33L24.54,795.17H893.6Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,752.17,289.64,585,434.27,334.57V0Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M483.72,0V334.57L628.35,585.13l289.79,167.2Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.38,578.39H350.59l24.69-42.85,59-102.15L459,390.6l24.76,42.79,59,102.3Z",
    transform: "translate(0 0.05)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1491.41,795.23H1235.58q-45,0-76.49-29.83t-31.51-74.75V569.4q0-44.91,31.51-74.74t76.49-29.83h255.83V542H1235.58q-30.86,0-30.85,27.53V690.56q0,27.54,30.85,27.53h255.83Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1911.79,795.23H1806.38L1641.17,610.11H1839.8q21.21,0,21.21-34.08T1839.8,542H1600.68V795.23h-77.14V464.83H1844.3q44.35,0,70.06,34.71,23.78,31.5,23.79,76.49t-23.79,76.49q-25.71,34.72-70.06,34.71h-29.57Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2399.67,795.23h-77.13V594L2185,790.08,2047.42,594v201.2h-77.14V464.83h81L2185,655.74l134.34-190.91h80.35Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605.36,340.91h-103.2L2340.52,155.7h194.4c13.78,0,20.68-11.4,20.68-34s-7-34.11-20.68-34.11H2300.87V340.83h-75.45V10.47h313.84c28.93,0,51.81,11.48,68.58,34.71,15.48,21,23.39,46.62,23.39,76.57s-7.91,55.47-23.39,76.48Q2582.69,233,2539.26,233h-28.84Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3021.13,87.55H2751.26v49.6H3003.6v77H2751.26v49.6h269.28v77.17H2675.9V10.47h345.23Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3440.13,10.47,3275.34,340.91h-64.06L3045.72,10.47h84.4L3243.78,236.6l112-226.13Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3876.06,236.35c0,29.78-10.28,54.79-30.78,74.61s-45.52,29.87-74.88,29.87H3580.35q-43.91,0-75-29.87c-20.41-19.91-30.79-44.83-30.79-74.61V115c0-29.95,10.29-54.79,30.79-74.79s45.6-29.77,75-29.77H3770.4c29.28,0,54.38,10,74.88,29.77S3876.06,85,3876.06,115Zm-75.36-.17V115.11c0-18.29-10.21-27.56-30.21-27.56H3580.42c-20.06,0-30.11,9.27-30.11,27.56V236.18q0,27.44,30.11,27.48h190.07C3790.49,263.74,3800.7,254.47,3800.7,236.18Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4244.78,340.91h-324V10.47h75.54V263.74h248.51Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495,87.55H1349.12V340.91h-75.54V87.55h-146V10.47H1495Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.51,87.55H1610.65v49.6h252.42v77.08H1610.65v49.51h269.44v77.17H1535.27V10.47h345.24Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2058.57,0,1920.41,171.94l152.45,169.48h110.7l-149-176.79L2160.76,0Z",
    transform: "translate(0 0.05)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoCrm);
export default __webpack_public_path__ + "static/media/white-logo-crm.75665801e50ada92190fc4919c71c2aa.svg";
export { ForwardRef as ReactComponent };